// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1921":"cd8f7b7838329b35","2888":"74feaf3f865ca9ed","7482":"cd8f7b7838329b35","8625":"cd8f7b7838329b35"}[chunkId] + ".css";
};